var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.promptNumber}},[_vm._v("Go to >>")])}
var staticRenderFns = []

export { render, staticRenderFns }